<div class="subscriptions">
  <section class="subscriptions__section">
    <header class="subscriptions__header">
      <div class="subscriptions__header-copy">
        <h3 class="subscriptions__title">
          {{ 'app.components.subscriptions.title' | translate }}
        </h3>
        <p class="subscriptions__subtitle">
          {{ 'app.components.subscriptions.subtitle' | translate }}
        </p>
      </div>
    </header>

    <div class="subscriptions__body">
      @if (checkoutNotice() === 'success') {
        <p class="subscriptions__notice subscriptions__notice--success" role="status">
          {{ 'app.components.subscriptions.checkoutSuccess' | translate }}
          <button type="button" class="subscriptions__notice-dismiss" (click)="dismissNotice()">
            {{ 'app.components.subscriptions.dismiss' | translate }}
          </button>
        </p>
      }

      @if (checkoutNotice() === 'cancel') {
        <p class="subscriptions__notice" role="status">
          {{ 'app.components.subscriptions.checkoutCancel' | translate }}
          <button type="button" class="subscriptions__notice-dismiss" (click)="dismissNotice()">
            {{ 'app.components.subscriptions.dismiss' | translate }}
          </button>
        </p>
      }

      @if (checkoutNotice() === 'error') {
        <p class="subscriptions__notice subscriptions__notice--error" role="alert">
          {{ 'app.components.subscriptions.checkoutError' | translate }}
          <button type="button" class="subscriptions__notice-dismiss" (click)="dismissNotice()">
            {{ 'app.components.subscriptions.dismiss' | translate }}
          </button>
        </p>
      }

      @if (plansLoading() && plans().length === 0) {
        <p class="subscriptions__status">
          {{ 'app.components.subscriptions.loading' | translate }}
        </p>
      } @else if (plansError() && plans().length === 0) {
        <p class="subscriptions__status subscriptions__status--error" role="alert">
          {{ 'app.components.subscriptions.loadError' | translate }}
        </p>
      } @else {
        <div class="subscriptions__plans">
          @for (plan of planConfigs; track plan.id) {
            <article
              class="subscriptions__plan"
              [class.subscriptions__plan--base]="plan.id === 'base'"
              [class.subscriptions__plan--care]="plan.id === 'care'"
              [class.subscriptions__plan--family]="plan.id === 'family'"
              [class.subscriptions__plan--current]="isCurrent(plan.id)"
              [class.subscriptions__plan--recommended]="catalogPlan(plan.id)?.isRecommended && !isCurrent(plan.id)"
            >
              <div class="subscriptions__plan-head">
                <div class="subscriptions__plan-badge-row">
                  @if (isCurrent(plan.id)) {
                    <span class="subscriptions__plan-badge subscriptions__plan-badge--current">
                      {{ 'app.components.subscriptions.currentBadge' | translate }}
                    </span>
                  } @else if (catalogPlan(plan.id)?.isRecommended) {
                    <span class="subscriptions__plan-badge subscriptions__plan-badge--accent">
                      {{ 'app.components.subscriptions.recommended' | translate }}
                    </span>
                  }
                </div>

                <h4 class="subscriptions__plan-title">
                  {{ plan.titleKey | translate }}
                </h4>

                <div class="subscriptions__plan-price-row">
                  <p class="subscriptions__plan-price">
                    @if (formatPrice(plan.id); as priced) {
                      {{ priced.amount | currency: priced.currency:'symbol':'1.2-2' }}
                    } @else {
                      {{ plan.priceLabelKey | translate }}
                    }
                  </p>
                  <p class="subscriptions__plan-interval">
                    {{ plan.intervalNoteKey | translate }}
                  </p>
                </div>
              </div>

              <ul class="subscriptions__features">
                @for (feature of featureLines(plan.id); track feature.key) {
                  <li
                    class="subscriptions__feature"
                    [class.subscriptions__feature--off]="feature.state === 'disabled'"
                    [class.subscriptions__feature--unlimited]="feature.state === 'unlimited'"
                  >
                    <span class="subscriptions__feature-mark" aria-hidden="true"></span>
                    <span class="subscriptions__feature-text">{{ feature.text }}</span>
                  </li>
                } @empty {
                  <li class="subscriptions__feature subscriptions__feature--muted">
                    <span class="subscriptions__feature-mark" aria-hidden="true"></span>
                    <span class="subscriptions__feature-text">
                      {{ 'app.components.subscriptions.featuresLoading' | translate }}
                    </span>
                  </li>
                }
              </ul>

              <div class="subscriptions__plan-action">
                @if (isCurrent(plan.id)) {
                  <app-parent-button variant="ghost" [disabled]="true" [fullWidth]="true">
                    {{ 'app.components.subscriptions.currentBadge' | translate }}
                  </app-parent-button>
                } @else if (plan.id === 'base') {
                  <app-parent-button variant="ghost" [disabled]="true" [fullWidth]="true">
                    {{ 'app.components.subscriptions.included' | translate }}
                  </app-parent-button>
                } @else {
                  <app-parent-button
                    variant="primary"
                    [fullWidth]="true"
                    [loading]="checkoutLoadingId() === plan.id"
                    [disabled]="checkoutLoadingId() !== null"
                    (clicked)="startCheckout(plan.id)"
                  >
                    {{ 'app.components.subscriptions.upgrade' | translate }}
                  </app-parent-button>
                }
              </div>
            </article>
          }
        </div>
      }
    </div>
  </section>
</div>
